export const grid = {
  gap: {
    tablet: 24,
    desktop: 48,
    desktopLarge: 72,
  },
};
